<template>
    <div>
        <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
            {{ moduleTitle }}
        </ModuleTitleNav>
        <div class="section-line" />
        <fieldset :disabled="formDisabled">
            <b-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 135 (c)]
                    </div>
                    <div class="info-text">
                        The college may pool a portion of its Perkins funds
                        received under this Act with one or more Perkins eligible
                        recipients to support implementation of programs of
                        study through the professional development activities
                        described in Sec. 135(b).
                    </div>
                    <div class="info-text-emphasis">
                        If pooling will not be used, enter N/A.
                    </div>
                    <b-form-textarea
                        v-model="pooling"
                        :rows="3"
                    />
                </b-col>
            </b-row>
        </fieldset>
        <br>
        <b-row>
            <b-col>
                <LocalApplicationModuleActions
                    :is-loading="isSaving"
                    :is-disabled="formDisabled"
                    background-color="#006438"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';

const storeModuleName = 'poolingOfFunds';
// const storeModuleNamespace = 'localApplications/module';

export default {
    name: 'PoolingOfFunds',

    props: {
        // formDisabled: { type: Boolean, default: true },
    },

    data() {
        return {
            isSaving: false,
            moduleTitle: 'Pooling Of Funds',
            nextModule: { name: 'localApplication.AdministrativeFunds' },
            previousModule: { name: 'localApplication.EvaluationOfPrograms' },
        };
    },

    computed: {
        ...mapState('localApplication', {
            currentState: (state) => state.localApplicationData.state.currentState
        }),

        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            localApplicationModuleContent: `localApplication/module/${storeModuleName}/content`
        }),

        formDisabled() {
            return !this.isAuthorized('update', 'local_application', this.currentState);
        },

        pooling: {
            get() { return this.localApplicationModuleContent.pooling; },
            set(value) { this.updateContentField({ field: 'pooling', value }); }
        },
    },


    methods: {
        ...mapActions(`localApplication/module/${storeModuleName}`, {
            saveLocalApplicationModule: 'save',
            updateContentField: 'updateContentField'
        }),

        async saveForm() {
            this.isSaving = true;
            try {
                const response = await this.saveLocalApplicationModule();
                this.isSaving = false;
                Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                this.isSaving = false;
            }
        }
    }
};
</script>
